import useEditComment from '../../customHooks/useEditComment'
import styles from './editCommentComponent.module.css'
interface IEditCommentComponent{
    email:string,
    commentInfo:string,
    id:number,
    setdisplayEdit:Function;
}
const EditCommentComponent = ({ email, commentInfo, id,setdisplayEdit }:IEditCommentComponent ) => {
    const{ emailToEdit, commentInfoToEdit,
        setcommentInfoToEdit, setemailToEdit, editComment
    } = useEditComment(email, commentInfo, id,setdisplayEdit);
    return (
        <div className={`${styles.mainContainer}`}>
            <input type="text" value={emailToEdit} onChange={(e) => { setemailToEdit(e.target.value) }} />
            <textarea value={commentInfoToEdit} onChange={(e) => { setcommentInfoToEdit(e.target.value) }} ></textarea>
            <button onClick={() => { editComment() }}>Edit comment</button>
            <button onClick={()=>setdisplayEdit(false)}>Cancel</button>
        </div>
    )
}

export default EditCommentComponent